import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from "../context/TranslationContext";
import config from '../config'; 

import '../styles/Select.css';

const Select = ({ options = [], colors = [], value, onChange, placeholder, label }) => {
  const { t } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selected, setSelected] = useState(value);
  const dropdownRef = useRef(null);
 
  const handleSelect = (item) => {
    setIsDropdownOpen(false);
    setSelected(item);
    if(onChange) {
      onChange(item);
    }
  };

  useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsDropdownOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="select-container">
      {label && <label className="select-label">{label}</label>} 
      <div className={value?"select-item":"select-item-hint"} onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
        <div className="select-option-item" style={{ backgroundColor: "var(--"+config.stateColors[value]+")" }} >{selected?t.state[selected]:placeholder}</div>
      </div>

      <div className="select-arrow">{'>'}</div>

      {isDropdownOpen && (
        <div className="select-dropdown" ref={dropdownRef}>
          {options.map((item,index) => (
            <div key={"select-"+item} className={selected===item?"select-option-selected":"select-option"} onClick={() => handleSelect(item)} >
              <div className="select-option-item" style={{ backgroundColor: "var(--"+config.stateColors[item]+")" }}>{t.state[item]}</div>
            </div>
          ))}
        </div>
      )}


    </div>
  );
};

export default Select;